module.exports = __webpack_public_path__ + "img/zero-motorcycles-hero.9a19715f.jpg";